import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Button } from "components";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useSelector } from "react-redux";
import { getCreativeTypes } from "store/features/materialSpecs/specs";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";

export const MaterialSpecTypeMenu = () => {
    const { t } = useTranslation();
    const { defaultFilter, setDefaultFilter } = useMaterialSpecs();
    const creativeTypes = useSelector(getCreativeTypes);
    const [anchorEl, setAnchorEl] = React.useState<(EventTarget & HTMLButtonElement) | null>(null);
    const open = Boolean(anchorEl);

    // eslint-disable-next-line
    const handleOpen = (e: any) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = (name?: string, value = "") => {
        setAnchorEl(null);

        if (name) {
            setDefaultFilter(name, value);
        }
    };

    return (
        <>
            <Button
                disableRipple
                color="inherit"
                aria-controls="fade-menu"
                aria-haspopup="true"
                onClick={handleOpen}
                variant="outlined"
                startIcon={<KeyboardArrowDownIcon />}>
                {defaultFilter.name}
            </Button>
            <Menu
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose()}>
                <MenuItem onClick={() => handleClose(t("buttons.label.all"))}>{t("buttons.label.all")}</MenuItem>
                {creativeTypes.map((creativeType, index) => {
                    return (
                        <MenuItem key={index} onClick={() => handleClose(creativeType, creativeType)}>
                            {creativeType}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};
